import React, { Component } from 'react';
import './App.css';
import ArrowButton from './ArrowButton';
import ContactForm from './ContactForm';
import ScrollableAnchor from 'react-scrollable-anchor'
import { goToAnchor } from 'react-scrollable-anchor'
import portrait from './images/nickkraly_portrait_2018.png'

class Tray extends Component {
  constructor (props) {
    super(props)
    this.state = { 
      displayDiscuss: false,
    }
    
    this.handleClose=this.handleClose.bind(this)
    this.handleDiscuss=this.handleDiscuss.bind(this)
  }

  handleDiscuss () {
    //<ArrowButton btlabel="discuss a project" buttonCB={this.handleDiscuss} height="17" width="15">
    this.setState({displayDiscuss:true})
  }

  handleLinkedIn () {
      window.open("https://www.linkedin.com/in/nickkraly/")
  }

  handleNavToNW () {
    goToAnchor('flowers')
  }

  handleNavToTech () {
    goToAnchor('tech')
  }

  handleNavToWork () {
    goToAnchor('work')
  }

 handleCV () {
    window.open("http://oddmachine.design/static/media/nickkraly_resume_2018_v1.8670efa6.pdf")
  }
  


  setContent(){
    return (

      <div className="trayContents">
      <div className="traySubNav">
      
      <ArrowButton btlabel="on LinkedIn" buttonCB={this.handleLinkedIn} height="17" width="15" />
      <ArrowButton btlabel="work" buttonCB={this.handleNavToWork} height="17" width="15" />  
      <ArrowButton btlabel="Non-work" buttonCB={this.handleNavToNW} height="17" width="15" />  
      <ArrowButton btlabel="Technical" buttonCB={this.handleNavToTech} height="17" width="15" />  
      <ArrowButton btlabel="CV" buttonCB={this.handleCV} height="17" width="15" /> 
      </div>
      <div className={this.state.displayDiscuss ? 'emailTxtArea show' : 'emailTxtArea hide' }>
      <div className="horizontalRule">.</div>
      <ContactForm />
      <div className="horizontalRule"></div>
      </div>

      <div className="traySection white">
      <img src={portrait} width="278" height="236" />
      <p className="heavy dkgray">Oddmachine is the business identity of Nick Kraly.</p>
      <p className="bold bottomspacer">Depending on availability and timing there are a variety of ways to engage: </p>
      <div className="threeColumn">
      <div className="contentColumn">
      <span className="bold">As a strategic consultant </span>
      billing hourly to pre-set weekly maximums.
      <ul>
      <li>planning or expanding your UX organization</li>
      <li>planning and organizing your UX project</li>
      <li>research planning, information architecture, redesign prep</li>
      </ul>
      </div>
      <div className="contentColumn">
      <span className="bold">On a per project basis</span>
      fixed cost billed 50% up front, 50% upon 
      project completion. 
      <ul>
      <li>executing entire projects from ideation to launch: mobile/tablet apps, product UX</li>
      <li>brand, design or UX only projects on a set schedule</li>
      <li>prototype construction</li>
      </ul>
      </div>
      <div className="contentColumn">
      <span className="bold">Onsite or remote team member</span>
      3-12 month contract, billing hour to
      pre-set weekly maximums
      <ul>
      <li>design Leadership</li>
      <li>parachuting into a project as a team member</li>
      <li>prototype construction</li>
      </ul>
      </div>
      </div>
      <p className="bold">[  SF is my primary location, but I’m happy to work remotely in any time zone. ]</p> 
      </div> 
      
    {/* end of first section */}
<ScrollableAnchor id={'flowers'}>
    <div className="trayWrapper">
    <div className="trayBackground flowers"></div>
    <div className="traySection flowers">
    <p className="heavy">When I'm not working . . .</p>
    <p>I’m spending time at home with my wife and brand new daughter</p>
    <p>I’m writing and recording music</p>
    <p>I’m surfing</p>
    <p>I'm practicing yoga</p>
    <p>I’m playing disc golf</p>
    <p>I’m listening to records</p>
    <p>Living in Glen Park, San Francisco</p>
    </div>
    </div>
  </ScrollableAnchor>
  <ScrollableAnchor id={'work'}>
    <div className="traySection white">
    <p className="heavy">When I am working . . .</p>
    <p>I’m leading ux teams through high-profile product design projects </p>
    <p>I’m building ux teams through hiring and solid management</p>
    <p>I’m working with the executive level on strategic product direction</p>
    <p>I'm learning everything to be learned about the user through research</p>
    <p>I’m exploring the latest technologies and design thinking</p>
    <p>I’m rolling up my sleeves and getting it done</p>
    </div>
  </ScrollableAnchor>
  {/* end of second section */}
  <ScrollableAnchor id={'tech'}>
<div className="trayWrapper">
    <div className="trayBackground tech"></div>
    <div className="traySection tech">
    <p className="heavy">Engineering & Technology</p>
    <p>This website was designed, created and produced by Nick Kraly, using Sketch, Sublime, Zepelin and React. The site is hosted on a NodeJS droplet on Digital Ocean and is served by NGINX.
    While I would never take a full-time code project, I do like to get deep into how things work so that I can create better designs. </p>

    <p>API Management, Containers and Error Management are a few of the developer-oriented technologies I've worked with in the UX context. Making complex technical concepts accessible to the user is a favorite challenge!</p>

<p>I'm comfortable with: </p>
<ul><li>Sketch</li>
<li>Javascript</li>
<li>React</li>
<li>CSS & HTML</li>
<li>Axure (prototyping)</li>
<li>Justinmind (prototyping)</li>
<li>Adobe stuff, though I don't use Adobe products often anymore</li>
</ul>

    </div>
    </div>
</ScrollableAnchor>


  </div>
    )
}

handleClose(){
  this.props.appCB()
}


render() {

 return (
   <div className="tray">
   <div className="positionCB">
   <div onClick={this.handleClose} className="closeButton dkgray"></div>
   </div>

   {this.setContent()}
   </div>

   );
}
}

export default Tray;


// WEBPACK FOOTER //
// ./src/Tray.js